import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import GroupsWithAccessSkeleton from './GroupsWithAccessSkeleton/GroupsWithAccessSkeleton'
import StoreGroups from './StoreGroups/StoreGroups'
import { getGroupsByStore } from './helpers'
import * as Styles from './styles'

const GroupsWithAccess = ({ groups, selectedGroupIds, fixedGroupIds, loading, onToggleGroup }) => {
  const { t } = useTranslation()
  const groupsByStore = getGroupsByStore(groups)
  const showStoreNames = groupsByStore.length > 1

  if (loading) {
    return <GroupsWithAccessSkeleton />
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Grupos con acceso')}</Text>
      <Styles.Stores>
        {groupsByStore.map(store => (
          <StoreGroups
            key={store.id}
            store={store}
            showName={showStoreNames}
            selectedGroupIds={selectedGroupIds}
            fixedGroupIds={fixedGroupIds}
            onToggleGroup={onToggleGroup}
          />
        ))}
      </Styles.Stores>
    </Styles.Container>
  )
}

export default GroupsWithAccess
